import { render, staticRenderFns } from "./CustomViewTask.vue?vue&type=template&id=4bcb218b&scoped=true"
import script from "./CustomViewTask.vue?vue&type=script&lang=js"
export * from "./CustomViewTask.vue?vue&type=script&lang=js"
import style0 from "./CustomViewTask.vue?vue&type=style&index=0&id=4bcb218b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcb218b",
  null
  
)

export default component.exports